import {useState} from 'react';
import {CheckboxItem} from '@radix-ui/react-context-menu';
import { MenuItem, toast } from '../../vendor/ds-react';
import { ContextMenuItem, ContextMenuSeparator } from '../../vendor/src/features/remotion-editor/editor/context-menu';
import { useFullState, useWriteContext } from '../../vendor/src/features/remotion-editor/editor/utils/use-context';
import { applyCaptionStyle, captionStyleTargets, type CaptionStyleScope } from './caption-style';
import { editorUserMessage } from '../../protocol/user-message';

export function CaptionStyleContextMenu({clipId}:{clipId:string}) {
  const state = useFullState(), {setState} = useWriteContext();
  const [includeLayout,setIncludeLayout]=useState(false);
  // Nested/group captions have no direct timeline scope; avoid crashing their context menu.
  let plans;
  try {plans={track:captionStyleTargets(state,clipId,'track'),all:captionStyleTargets(state,clipId,'all')};}
  catch {return null;}
  const run = (scope:CaptionStyleScope) => {
    try {
      const result = applyCaptionStyle(state,clipId,scope,includeLayout);
      if (!result.changed) {
        toast({type:'success',description:'이미 같은 스타일입니다.'});
        return;
      }
      setState({commitToUndoStack:true,update:prev => {
        if (prev.undoableState !== state.undoableState) return prev;
        return {...prev,undoableState:result.state.undoableState};
      }});
      toast({type:'success',description:`자막 ${result.changed}개에 적용했습니다.${result.skipped ? ` 잠긴 자막 ${result.skipped}개는 유지했습니다.` : ''} 되돌리기로 복구할 수 있습니다.`});
    } catch(error) {toast({type:'error',description:editorUserMessage(error)});}
  };
  return <><ContextMenuSeparator/><CheckboxItem onPointerDown={e=>e.stopPropagation()} checked={includeLayout} onCheckedChange={v=>setIncludeLayout(v===true)} onSelect={e=>e.preventDefault()} className="rounded-xs outline-none focus:bg-sys-bg-surface-1-hover"><MenuItem size="md" showLeadingIcon={false} text="위치·너비도 함께 적용" subText={includeLayout?'✓':'선택 사항'} className="w-full"/></CheckboxItem>{(['track','all'] as const).map(scope => {
    const {targetIds,skipped}=plans[scope];
    return <ContextMenuItem key={scope} onPointerDown={e=>e.stopPropagation()} onSelect={()=>run(scope)}
      title="문구·시간·위치·너비는 유지합니다. 자막 높이는 글꼴과 줄 수에 맞춰 조정됩니다.">
      <MenuItem size="md" showLeadingIcon={false} className="w-full"
        text={scope==='track'?'같은 트랙 자막에 스타일 적용':'전체 자막에 스타일 적용'}
        subText={`${targetIds.length}개${skipped?` · 잠금 ${skipped}개 제외`:''}`}/>
    </ContextMenuItem>;
  })}</>;
}
